<template>
  <a-layout class="container">
    <!-- 左侧区域 -->
    <hina-base-slider
      :currentMenuKey="curMenuKey"
      :currentOpenKey="curOpenKey"
    />
    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user="objUserInfo" />

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link="arrBreadLink" />

        <div class="wrapper">
          <div class="wrap">
            <div class="hd">密码维护</div>
            <div class="bd">
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">旧密码</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmResetPassword.oldPassword"
                    type="password"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">新密码</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmResetPassword.newPassword"
                    type="password"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">确认密码</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="confirmPassword"
                    type="password"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :offset="4" :span="10" class="btn">
                  <a-button type="primary" @click="handleResetPassword"
                    >修改密码</a-button
                  >
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="wrap">
            <div class="hd">企业档案</div>
            <div class="bd">
              <a-row class="frm-line">
                <a-col :span="4" class="lab">公司账号</a-col>
                <a-col :span="6" class="txt">{{
                  frmCompany.corporateAccount
                }}</a-col>
                <a-col :span="4" class="lab">企业编码</a-col>
                <a-col :span="6" class="txt">{{
                  frmCompany.enterpriseCode
                }}</a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">公司全名</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.enterpriseFullName"
                    type="text"
                    :disabled="true"
                    autocomplete="off"
                  />
                </a-col>
                <a-col :span="4" class="lab">公司简称</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.enterpriseAbbreviation"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">统一社会信用代码</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.businessLicenseNumber"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
                <a-col :span="4" class="lab">公司办公地址</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.address"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">开户行</a-col>
                <a-col :span="6" class="txt">
                    <a-select
					size="large"
					v-model="frmCompany.openingBank"
                      @change="onchange"
                    >
                      <a-select-option
                        v-for="item in openingBankList"
                        :value="item.dictCode.toString()"
                        :key="item.dictCode"
                      >
                        {{item.dictName}}</a-select-option
                      >
                    </a-select>
                </a-col>
                <a-col :span="4" class="lab">开户账号</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.broughtAccount"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">税号</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.dutyParagraph"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
                <a-col :span="4" class="lab">对公账户名称</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.companyAccount"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">法人姓名</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.legalRepresentativeName"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
                <a-col :span="4" class="lab">法人联系电话</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.contactNumber"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :span="4" class="lab required">联系人姓名</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.enterpriseContact"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
                <a-col :span="4" class="lab required">联系人电话</a-col>
                <a-col :span="6" class="txt">
                  <a-input
                    v-model="frmCompany.enterpriseContactNumber"
                    type="text"
                    autocomplete="off"
                  />
                </a-col>
              </a-row>
              <a-row class="frm-line">
                <a-col :offset="4" :span="10" class="btn">
                  <a-button type="primary" @click="handleUpdateProfile"
                    >修改档案</a-button
                  >
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from "components/HinaBaseSlider/HinaBaseSlider";
import HinaUserInfo from "components/HinaUserInfo/HinaUserInfo";
import HinaBreadCrumb from "components/HinaBreadCrumb/HinaBreadCrumb";
import utils from "assets/js/util";

export default {
  name: "Profile",
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb,
  },
  data() {
    return {
      objUserInfo: {},
      curMenuKey: ["profile"],
      curOpenKey: ["sub3"],

      arrBreadLink: [],

      frmResetPassword: {
        oldPassword: "",
        newPassword: "",
      },
      confirmPassword: "",

      frmCompany: {
        id: "",
        corporateAccount: "", // 公司账号
        enterpriseFullName: "", // 公司全名
        enterpriseAbbreviation: "", // 公司简称
        address: "", // 公司地址
        businessLicenseNumber: "", // 统一社会信用代码
        legalRepresentativeName: "", // 法人姓名
        contactNumber: "", // 法人电话
        enterpriseContact: "", // 联系人姓名
        enterpriseContactNumber: "", // 联系人电话
      },
      openingBankList: [],
    };
  },
  methods: {
    // 读取字典
    getDictBuyer() {
      this.$get("enterpriseInformation/buyerData").then((res) => {
        if (res.success) {
          this.openingBankList = res.result;
        }
      });
    },
    onchange(value) {
      console.log(value);

    },
    //修改密码
    handleResetPassword() {
      if (this.frmResetPassword.oldPassword === "") {
        this.$message.error("请输入旧密码");
        return;
      }
      if (this.frmResetPassword.newPassword === "") {
        this.$message.error("请输入新密码");
        return;
      }
      if (this.confirmPassword === "") {
        this.$message.error("请再次输入新密码");
        return;
      }
      if (this.frmResetPassword.newPassword !== this.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      if (
        this.frmResetPassword.newPassword === this.frmResetPassword.oldPassword
      ) {
        this.$message.error("新密码不能与旧密码相同");
        return;
      }
      //密码强度校验
      if (!utils.checkPassword(this.frmResetPassword.newPassword)) {
        this.$message.error(
          "密码必须包含数字、字母、特殊字符中的两种，且长度不小于8位"
        );
        return;
      }
      let params = {
        oldPassword: this.$md5(this.frmResetPassword.oldPassword),
        newPassword: this.$md5(this.frmResetPassword.newPassword),
      };
      this.$post("enterpriseInformation/updatePassword", params, true)
        .then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.result);
            this.frmResetPassword = {
              oldPassword: "",
              newPassword: "",
            };
            this.confirmPassword = "";
          }
          //捕获异常
        })
        .catch((err) => {
          if (err.response.data.code == 25016) {
            this.$message.error(err.response.data.message);
          }
        });
    },
    //修改档案
    handleUpdateProfile() {
      let result = utils.checkData(this.frmCompany);
      console.log(result);
      if (result == "success") {
        this.$put("enterpriseInformation/update", this.frmCompany, true)
          .then((res) => {
            if (res.data.success) {
              this.$message.success("修改成功");
              let data = res.data.result;
              localStorage.setItem("userInfo", JSON.stringify(data));
              this.$store.dispatch("actUserInfo", data);
              this.objUserInfo =
                JSON.parse(localStorage.getItem("userInfo")) ||
                this.$store.state.userInfo;
            }
            //捕获异常
          })
          .catch((err) => {
            if (err.response.data.code == 4002) {
              this.$message.error(err.response.data.message);
            } else {
              this.$message.error("修改失败");
            }
          });
      } else {
        this.$message.error(result);
      }
    },
  },
  mounted: function () {
    this.objUserInfo =
      this.$store.state.userInfo ||
      JSON.parse(localStorage.getItem("userInfo"));
    this.arrBreadLink.push({ name: "企业信息", link: "/profile" });
    this.frmCompany =
      JSON.parse(localStorage.getItem("userInfo")) ||
      this.$store.state.userInfo;
      
    this.getDictBuyer();
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #fff;
    min-height: 240px;
    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;
      &::after {
        position: absolute;
        content: "";
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
    .bd {
      padding: 0 0 30px;
      .frm-line {
        min-height: 72px;
        padding: 12px 0;
        box-sizing: border-box;
        .lab {
          font-size: 16px;
          line-height: 48px;
          text-align: right;
          position: relative;
          &::after {
            position: relative;
            content: "：";
          }
        }
        .required {
          &::before {
            position: relative;
            content: "*";
            color: red;
            padding: 0 5px 0 0;
          }
        }
        .txt {
          line-height: 48px;
          font-size: 16px;
        }
      }
    }
  }
  .wrap:first-of-type {
    margin: 0;
  }
}
/deep/ .ant-select{
	display: block;
}
</style>